import { render, staticRenderFns } from "./PriorityOfferWhitelist.vue?vue&type=template&id=0ddf36a4&"
import script from "./PriorityOfferWhitelist.vue?vue&type=script&lang=js&"
export * from "./PriorityOfferWhitelist.vue?vue&type=script&lang=js&"
import style0 from "./PriorityOfferWhitelist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports